var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmiley(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 66,
    viewBox: "0 0 170 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.896 3.03516C167.649 1.13435 165.558 0 163.302 0H136.825C134.55 0 132.433 1.18387 131.148 3.17901C121.008 19.1826 103.748 28.7338 84.9898 28.7338C66.2313 28.7338 48.9903 19.1802 38.8499 3.18374C37.5934 1.18859 35.4744 0 33.1829 0H6.69664C4.44011 0 2.34909 1.13435 1.10194 3.03516C-0.124238 4.90059 -0.338704 7.24005 0.516819 9.29179C14.8742 43.7374 48.0368 66 84.9922 66C121.948 66 155.131 43.7398 169.484 9.29179C170.339 7.24005 170.123 4.90059 168.899 3.03516H168.896Z",
    fill: "#EB3A25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley);
export default __webpack_public_path__ + "static/media/smiley.61507f11e51a356d9152fac423b79bbf.svg";
export { ForwardRef as ReactComponent };